export const CH31_CASE_MILESTONES_RESET_STATE =
  'CH31_CASE_MILESTONES_RESET_STATE';
export const CH31_CASE_MILESTONES_FETCH_STARTED =
  'CH31_CASE_MILESTONES_FETCH_STARTED';
export const CH31_CASE_MILESTONES_FETCH_SUCCEEDED =
  'CH31_CASE_MILESTONES_FETCH_SUCCEEDED';
export const CH31_CASE_MILESTONES_FETCH_FAILED =
  'CH31_CASE_MILESTONES_FETCH_FAILED';

export const CH31_CASE_STATUS_DETAILS_FETCH_STARTED =
  'CH31_CASE_STATUS_DETAILS_FETCH_STARTED';
export const CH31_CASE_STATUS_DETAILS_FETCH_SUCCEEDED =
  'CH31_CASE_STATUS_DETAILS_FETCH_SUCCEEDED';
export const CH31_CASE_STATUS_DETAILS_FETCH_FAILED =
  'CH31_CASE_STATUS_DETAILS_FETCH_FAILED';

export const CH31_CASE_STATUS_DETAILS_ERROR_400_BAD_REQUEST =
  'CH31_CASE_STATUS_DETAILS_ERROR_400_BAD_REQUEST';
export const CH31_CASE_STATUS_DETAILS_ERROR_403_FORBIDDEN =
  'CH31_CASE_STATUS_DETAILS_ERROR_403_FORBIDDEN';
export const CH31_CASE_STATUS_DETAILS_ERROR_500_SERVER =
  'CH31_CASE_STATUS_DETAILS_ERROR_500_SERVER';
export const CH31_CASE_STATUS_DETAILS_ERROR_503_UNAVAILABLE =
  'CH31_CASE_STATUS_DETAILS_ERROR_503_UNAVAILABLE';

// Returned by RES when a case has been transferred to CWNRS
export const CH31_CASE_STATUS_NO_APP_IN_RES_CODE = 'NO_APP_IN_RES';

export const CH31_PDF_LETTER_DOWNLOAD_STARTED =
  'CH31_PDF_LETTER_DOWNLOAD_STARTED';
export const CH31_PDF_LETTER_DOWNLOAD_SUCCEEDED =
  'CH31_PDF_LETTER_DOWNLOAD_SUCCEEDED';
export const CH31_PDF_LETTER_DOWNLOAD_FAILED =
  'CH31_PDF_LETTER_DOWNLOAD_FAILED';

export const CH31_PDF_LETTER_DOWNLOAD_ERROR_400_BAD_REQUEST =
  'CH31_PDF_LETTER_DOWNLOAD_ERROR_400_BAD_REQUEST';
export const CH31_PDF_LETTER_DOWNLOAD_ERROR_403_FORBIDDEN =
  'CH31_PDF_LETTER_DOWNLOAD_ERROR_403_FORBIDDEN';
export const CH31_PDF_LETTER_DOWNLOAD_ERROR_404_NOT_FOUND =
  'CH31_PDF_LETTER_DOWNLOAD_ERROR_404_NOT_FOUND';
export const CH31_PDF_LETTER_DOWNLOAD_ERROR_500_SERVER =
  'CH31_PDF_LETTER_DOWNLOAD_ERROR_500_SERVER';
export const CH31_PDF_LETTER_DOWNLOAD_ERROR_503_UNAVAILABLE =
  'CH31_PDF_LETTER_DOWNLOAD_ERROR_503_UNAVAILABLE';

export const MILESTONE_COMPLETION_TYPES = {
  STEP_3: 'ORIENTATION_COMPLETION',
  STEP_4_INTAKE_MEETING_COMPLETION: 'INTAKE_MEETING_COMPLETION',
  STEP_4_CODE_OF_CONDUCT_COMPLETION:
    'INITIAL_EVA_STEP_CODE_OF_CONDUCT_COMPLETED',
};

export const YOUTUBE_ORIENTATION_VIDEO_URL =
  'https://www.youtube.com/watch?v=49eWvGitLPw';

export const VRE_FACT_SHEET_URL =
  'https://www.va.gov/files/2026-05/veteran-readiness-information-sheet.pdf';
